import { NumberFormatter as MantineNumberFormatter } from '@mantine/core';
import clsx from 'clsx';

export const NumberFormatter = MantineNumberFormatter.extend({
	defaultProps: {
		thousandSeparator: ' ',
		className: clsx('mantine-NumberFormatter-root', 'native'),
	},
});
